
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IActionCriteria } from "@tylertech/tyler-api-types";

/**
 * InventoryService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InventoryService<T = unknown> {
    private readonly $apiService = inject(ApiService);
    
    GetAdjustmentMetadataAction(): Promise<any> {
        return this.$apiService.sendAuth("IInventoryService/GetAdjustmentMetadataAction");
    }
    PerformAction(pCriteria: IActionCriteria): Promise<any> {
        return this.$apiService.sendAuth("IInventoryService/PerformAction", pCriteria);
    }
    SaveNewItem(pItem: T): Promise<string> {
        return this.$apiService.sendAuth("IInventoryService/SaveNewItem", pItem);
    }
}
